import * as React from "react";
import { connect } from "react-redux";
import { match } from "react-router";
import { mapDispatchToProps } from "../../redux/actions";
import { addNotification, removeNotification } from "../../api-utilities/notification-tools";
import { getUnitCabinetInputValues } from "../../api-calls/readApiService";
import { isEmptyObject } from "../../utilities/helpers";
import Exterior from "./Cabinet/Exterior";
import Interior from "./Cabinet/Interior";
import Doors from "./Cabinet/Doors";
import "../../css/Accordions.scss";

// expected props
interface IProps {
  updateRedux: any;
  match: match<any>;
}
// local state
interface IState {
  componentData: any;
}

class UnitCabinet extends React.Component<IProps, IState> {
  public state: IState = {
    componentData: null
  };
  async componentDidMount() {
    const { projectId, unitId } = this.props.match.params;
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: true });
    const result = await getUnitCabinetInputValues(projectId, unitId);
    this.props.updateRedux("UPDATE_DISPLAY", { showLoader: false });

    if (result.hasError){
      const notification = {
        id: "cabinetInputsError",
        notificationType: "error",
        title: "Error",
        content: <div className="nf-div">GetUnitCabinetInputValues {result.errorMessage}</div>
      };
      addNotification(notification);
    }

    if (!isEmptyObject(result.uiDataContainer)) {
      this.setState({
        componentData: result
      });
    }
  }

  public render() {
    const componentData = this.state.componentData;

    if (isEmptyObject(componentData)) {
      return null;
    }
    return (
      <div className="spec-body-content-wide">
        {/* <div className="spec-copy-btn">Copy Values From:</div> */}
        {/* <div className="spec-unit-copy">
          <select className="spec-unit-selectbox" value="" onChange={(event) => {}}>
            <option>choose</option>
            { {this.getSelectOptions('')} }
          </select>
        </div> */}

        <div className="spec-field-spacer2"></div>

        <div className="spec-page-division">
          <Exterior componentData={componentData} match={this.props.match} />
        </div>

        <div className="spec-page-division">
          <Interior componentData={componentData} match={this.props.match} />
        </div>

        <div className="spec-page-division">
          <Doors componentData={componentData} match={this.props.match} />
        </div>
      </div>
    );
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UnitCabinet);
